
















































import { computed, defineComponent, ref } from '@vue/composition-api'
import PageRow from '@/components/organisms/questionnaire/PageRow.vue'
import DeleteDialog from '@/components/organisms/questionnaire/DeleteDialog.vue'
import { IPage, IQuestion } from '@/types/questionnaire'
import QuestionRow from '@/components/organisms/questionnaire/QuestionRow.vue'

type Props = {
  pages: IPage[]
  isAutomatic: boolean
}

export default defineComponent({
  name: 'QuestionnairePageTable',
  components: { PageRow, QuestionRow, DeleteDialog },
  props: {
    pages: {
      type: Array,
      default: () => [],
    },
    isAutomatic: {
      type: Boolean,
      default: true,
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store
    const id = context.root.$route.params.id

    const state = ref<{
      deleteDialog: boolean
      deletePageId: number | null
      deleteQuestionId: number | null
      deleteName: string | null
    }>({
      deleteDialog: false,
      deletePageId: null,
      deleteQuestionId: null,
      deleteName: null,
    })

    const items = computed(() =>
      props.pages.map(page => [page, ...page.questions]).flat(),
    )

    const findPage = (pageId: number) => {
      return props.pages.find(page => page.id === pageId)
    }

    const onDeletePage = (page: IPage) => {
      state.value.deleteDialog = true
      state.value.deletePageId = page.id
      state.value.deleteQuestionId = null
      state.value.deleteName = page.sentence
    }

    const onDeleteQuestion = (question: IQuestion) => {
      state.value.deleteDialog = true
      state.value.deletePageId = null
      state.value.deleteQuestionId = question.id
      state.value.deleteName = question.questionText
    }

    const onDelete = async () => {
      if (state.value.deletePageId) {
        await store.dispatch(
          'questionnaire/deleteQuestionnairePage',
          state.value.deletePageId,
        )
      } else if (state.value.deleteQuestionId) {
        await store.dispatch(
          'questionnaire/deleteQuestion',
          state.value.deleteQuestionId,
        )
      }
      state.value.deleteDialog = false
    }

    const qType = props.isAutomatic ? 'automatic' : 'manual'

    return {
      id,
      items,
      state,
      findPage,
      onDeletePage,
      onDeleteQuestion,
      onDelete,
      qType,
      props,
    }
  },
})
